export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd367af3dc35a164fc3c5391913e75d641caa33d4&name=fetchTypeahead!'